// @core/api/endpoints/authn/grant_oauth2_consent.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GrantOAuth2ConsentRequest,
  OAuth2ConsentResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Grant OAuth2 consent
 * Records the user's consent for an OAuth2 client to access specific scopes. Consent can be granted with an optional expiration time for temporary access.
 */
export async function GrantOAuth2Consent(
  data: GrantOAuth2ConsentRequest,
  options?: RequestOptions
): Promise<OAuth2ConsentResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/consents`;
  const requestOptions = options;
  return client.post<OAuth2ConsentResponse>(requestPath, data, requestOptions);
}
